"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getLangCountry_1 = require("./getLangCountry");
var getSiteName_1 = require("./getSiteName");
var utils_1 = require("../utils");
// Getting Page Name with browser default props
var getPageName = function () {
    var pageName = "";
    var locationPathname = (0, utils_1.removeSpecialCharacters)(window.location.pathname) || "";
    var lastIndex = locationPathname.split("/");
    ;
    var lastSection = lastIndex[lastIndex.length - 1];
    var siteName = (0, getSiteName_1.default)();
    if (lastSection === "") {
        var lastSection_1 = lastIndex[lastIndex.length - 2];
        pageName = "".concat(siteName, "|").concat((0, getLangCountry_1.default)(), "|").concat(lastSection_1 !== "" ? lastSection_1.replace(".", "-") : "home");
    }
    else {
        pageName = "".concat(siteName, "|").concat((0, getLangCountry_1.default)(), "|").concat(lastSection.replace(".", "-"));
    }
    return pageName.toLowerCase();
};
exports.default = getPageName;
